"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var constant_1 = require("./constant");
var style_1 = require("../../style");
var loadingAnimation = react_1.keyframes({
    '0%': {
        backgroundPosition: '-468px 0',
    },
    '100%': {
        backgroundPosition: '468px 0',
    },
});
var baseStyle = {
    container: react_1.css({
        padding: 4,
        '& .skeleton-root': {
            backgroundColor: style_1.SixsenseColor.Gray.LIGHT_3,
        },
        '& .skeleton-text': {
            borderRadius: 16,
        },
        '& .skeleton-text-size-body': {
            height: 16,
        },
        '& .skeleton-text-size-header': {
            height: 40,
        },
        '& .skeleton-avatar': {
            borderRadius: '100%',
        },
        '& .skeleton-avatar-size-xs': {
            width: 24,
            height: 24,
        },
        '& .skeleton-avatar-size-sm': {
            width: 32,
            height: 32,
        },
        '& .skeleton-avatar-size-md': {
            width: 40,
            height: 40,
        },
        '& .skeleton-avatar-size-lg': {
            width: 48,
            height: 48,
        },
        '& .skeleton-avatar-size-xl': {
            width: 56,
            height: 56,
        },
        '& .skeleton-avatar-size-2xl': {
            width: 64,
            height: 64,
        },
        '& .skeleton-rectangular': {
            width: '100%',
        },
        '& .skeleton-animate': {
            animation: loadingAnimation,
            animationDuration: '1.8s',
            animationFillMode: 'forward',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            backgroundImage: 'linear-gradient(to right,#E5E7EB 8%,rgba(0, 0, 0, 0.04) 38%,#E5E7EB 54%)',
            backgroundSize: '1000px 640px',
        },
    }),
    skeleton: react_1.css({
        display: 'inline-block',
        minHeight: 16,
    }),
};
var Skeleton = function (_a) {
    var _b, _c;
    var _d = _a.variant, variant = _d === void 0 ? constant_1.SkeletonVariant.TEXT : _d, _e = _a.textSize, textSize = _e === void 0 ? constant_1.TextSkeletonSize.BODY : _e, _f = _a.textWidthPercent, textWidthPercent = _f === void 0 ? 100 : _f, _g = _a.avatarSize, avatarSize = _g === void 0 ? constant_1.AvatarSkeletonSize.SM : _g, _h = _a.animate, animate = _h === void 0 ? true : _h, style = _a.style, props = __rest(_a, ["variant", "textSize", "textWidthPercent", "avatarSize", "animate", "style"]);
    var customContainerStyle = (_b = {},
        _b[constant_1.SkeletonVariant.TEXT] = {
            display: 'block',
        },
        _b[constant_1.SkeletonVariant.AVATAR] = {
            display: 'inline',
        },
        _b[constant_1.SkeletonVariant.RECTANGULAR] = {
            display: 'block',
        },
        _b);
    var customSkeletonStyle = (_c = {},
        _c[constant_1.SkeletonVariant.TEXT] = {
            width: textWidthPercent + "%",
        },
        _c[constant_1.SkeletonVariant.AVATAR] = {},
        _c[constant_1.SkeletonVariant.RECTANGULAR] = {},
        _c);
    return react_1.jsx("div", __assign({}, props, { css: [baseStyle.container, customContainerStyle[variant]] }),
        react_1.jsx(react_1.ClassNames, null, function (_a) {
            var cx = _a.cx;
            return (react_1.jsx("span", { className: cx('skeleton-root', "skeleton-" + variant, animate && 'skeleton-animate', variant !== constant_1.SkeletonVariant.RECTANGULAR &&
                    "skeleton-" + variant + "-size-" + (variant === constant_1.SkeletonVariant.TEXT ? textSize : avatarSize)), css: [baseStyle.skeleton, customSkeletonStyle[variant]], style: style }));
        }));
};
exports.default = Skeleton;
